"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const PopoverContext_1 = __importDefault(require("../../contexts/PopoverContext"));
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const JourneyAppContext_1 = require("../../contexts/JourneyAppContext");
const createRipple_1 = require("../../lib/createRipple");
const Button = (props) => {
    const { onClick, disabled, children } = props;
    const { inPopover, closeOnBtnClick, onClose: closePopover } = react_1.useContext(PopoverContext_1.default);
    const { error, setError } = react_1.useContext(JourneyAppContext_1.JourneyAppContext);
    const buttonRef = react_1.useRef(null);
    // Automatically disable the button if there onClick returns a promise.
    const onClickHandle = react_1.useCallback((e) => {
        createRipple_1.createRipple(e);
        // dont close until after the onClick is finished.
        const closePopoverHandle = () => {
            var _a;
            const targetClassName = (_a = e.target) === null || _a === void 0 ? void 0 : _a.className;
            const openingAnotherPopover = typeof targetClassName === 'string' && targetClassName.includes('j-select-button');
            if (inPopover && closeOnBtnClick && !openingAnotherPopover) {
                // on safari, it appears you must close the popover on next frame
                // or else it will cancel that onClick event because its a button click on a div (popover) that doesnt exist
                closePopover === null || closePopover === void 0 ? void 0 : closePopover();
            }
        };
        const r = onClick === null || onClick === void 0 ? void 0 : onClick(e);
        closePopoverHandle();
        return r;
    }, [closeOnBtnClick, closePopover, inPopover, onClick]);
    // have the count because we only wanna do this if its combo'd with text + icon.
    const iconComp = helpers_1.hasChildComponent(props, 'j-icon');
    const avatarComp = helpers_1.findChildComponent(props, 'j-avatar');
    const className = classnames_1.default({
        disabled,
        'has-error': (error === null || error === void 0 ? void 0 : error.message) && error.message !== '',
        'has-icon': iconComp,
        'only-avatar': avatarComp && !Array.isArray(avatarComp.siblings),
    });
    const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [buttonRef]);
    const primitiveProps = Object.assign(Object.assign({}, helpers_1.usePrimitiveProps(props, { className })), { ref: forwardedRef, onClick: onClickHandle });
    return (
    // eslint-disable-next-line react/button-has-type
    react_1.default.createElement("button", Object.assign({}, primitiveProps), children));
};
exports.default = withJourney_1.default('j-button', Button);
